import { useContext } from 'react';

import { QSetDetailsHeaderModalContext } from './qset-details-header-modal-provider';

function useQSetHeaderModal() {
  const context = useContext(QSetDetailsHeaderModalContext);

  if (!context) {
    throw new Error('useQSetHeaderModal must be used within a QSetDetailsHeaderModalProvider');
  }

  return context;
}

export { useQSetHeaderModal };
